import { render, staticRenderFns } from "./SfCircleIcon.vue?vue&type=template&id=16c86c75&"
import script from "./SfCircleIcon.vue?vue&type=script&lang=js&"
export * from "./SfCircleIcon.vue?vue&type=script&lang=js&"
import style0 from "./SfCircleIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports